import { centralizedAuth } from '@cimpress/simple-auth-wrapper';

const auth = new centralizedAuth({
  clientID: import.meta.env.VITE_CLIENT_ID,
  redirectRoute: '/',
});

export default auth;
